module.exports = __webpack_public_path__ + "static/kazim-yardimci-4-c0ed1fd3fd5ea72f68fe8e2c5404c144.jpg";